import { Component, EventEmitter, Input, Output } from '@angular/core';
import { defaultTheme } from 'src/app/theme/theme';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    standalone: false
})
export class PaginationComponent {
  @Input()
  theme = defaultTheme;

  @Input()
  pageSize: number;

  @Input()
  length: number;

  @Input()
  pageIndex = 0;

  @Output()
  page = new EventEmitter<number>();

  get textStyle() {
    return {
      color: this.theme.primaryDarkColor
    };
  }

  goFirst(): void {
    this.pageIndex = 0;
    this.page.emit(this.pageIndex);
  }

  goNext(): void {
    if (this.pageIndex + 1 < Math.ceil(this.length / this.pageSize)) {
      this.pageIndex++;
      this.page.emit(this.pageIndex);
    }
  }

  goPrev(): void {
    if (this.pageIndex - 1 >= 0) {
      this.pageIndex--;
      this.page.emit(this.pageIndex);
    }
  }

  goLast(): void {
    this.pageIndex = Math.ceil(this.length / this.pageSize) - 1;
    this.page.emit(this.pageIndex);
  }

  onSelect(): void {
    this.page.emit(this.pageIndex);
  }

  get pageList() {
    const p = Math.ceil(this.length / this.pageSize);
    return Array.from(Array(p).keys());
  }
}
